

import { useState } from 'react'
import { Navigate } from 'react-router';

import ImgBkg from'../../acets/bkglogin.jpg'


export default function Login(){

  
  
    const [sucesse,setSucess]=useState(false)
    //const [status, setStatus]=useState("")
    const initialValues={
        email:'',
        password:''
    }
    const [values,setValues]=useState(initialValues);
    
    
    function onchenge(ev) {
        const {name,value} = ev.target;
        setValues({ ...values, [name]:value });//SETANDO O VALUE EM NAME
    }
    function onSubmit(ev) {
        ev.preventDefault();
        if(values.email==="teste@gmail.com"&values.senha==="123"){
            setSucess(true)
        }
        else{
            alert("Usuario ou senha incorretos :(")
        }
    }


  return(
    <div className='w100 row center b26 h100'>
      {sucesse&&<Navigate to="/painel" />}
      <section className='cell-none h100 w60 cell-tamanho90 column around' style={{ backgroundImage: `url(${ImgBkg})`,backgroundSize:'cover', backgroundRepeat:'no-repeat' }} >
      <div className='column center w100'>
        <h1 >Hello</h1>
        <label className='c3 fb fs2p5em'>Post</label>
      </div>
      

      </section>
      <section className='h100 w40 cell-tamanho90 column around b2'>
          

          <div className=' h40 w80 cont-circ8  column center '>
            <label className='fs2p5em ' style={{'font-family': 'Yellowtail'}}>Hello</label>
            <label className='c1 fb'>Post</label>
            <div className='w100 row ma20b0'> 
              <div className='row between w50 '>
                <img src='https://cdn-icons-png.flaticon.com/128/7826/7826359.png' alt='Brasil' className='w10'/>
                <label className=' w80'>Posts prontos em 5 minutos</label>
              </div>
              <div className='row between w50'>
                <img src='https://cdn-icons-png.flaticon.com/128/197/197484.png' alt='Brasil' className='w10'/>
                <label className=' w80'>Posts ready in 5 minutes</label>
              </div>
            </div>
           
           
            
            <label className='fs08em c5 w100 ma25b0'>BETA VERSION 0.0.5V</label>
            <div className="w100">
              <form onSubmit={onSubmit}>
                <label className="w100 c1 fb">Email:</label>
                <input type="text" name="email"  onChange={onchenge} placeholder="Ex:joao@gmail.com"></input>
                <label className="w100 c1 fb">Senha/Password:</label>
                <input type="password" name="senha" onChange={onchenge} placeholder="*****"></input>
                <button className='w100 column center h5 ma10b0 pp cont-circ15' type="submit" >Login</button>
                <div className='w100 cen'>Or</div>
                <button className='w100 column center h5 ma10b0 pp cont-circ15 b3 c4'
                  onClick={()=>alert("Desculpe, no momento somente usuarios BETA  / Sorry, currently only BETA users")}
                >
                  Create new account</button>
              </form>

            </div>
          </div>
          <label className='fs08em ma10b0 w100 cen'> - Hello Post -</label> 
      </section>
      
      
      
      
    </div>
  )
}
